import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { LocalStorageService } from 'ngx-webstorage';
import { DtoService } from '../../services/dto.service';
import { FunctService } from '../../services/funct.service';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-forget-login-device-dialog',
  templateUrl: './forget-login-device-dialog.component.html',
  styleUrls: ['./forget-login-device-dialog.component.scss']
})

export class ForgetLoginDeviceDialogComponent implements OnInit {

  title: string;
  closeBtnName: string; 
  @Input() data: any = [];  

  launchGameResModel: any;

  constructor(
    private toastr: ToastrService,
    private http: HttpClient,
    private dto: DtoService, 
    private route: ActivatedRoute, 
    private funct: FunctService,
    private storage: LocalStorageService,
    public bsModalRef: BsModalRef,
    private translateService: TranslateService,
    private router: Router,
    public common: CommonService) {
   
  }

  ngOnInit() {  
    this.closeBtnName = this.translateService.instant('cancel');
  }

  close() {
    this.bsModalRef.hide();
  }

  handleError(error: HttpErrorResponse) {
      
    if (error.status == 0) {
      this.common.errorMsg("", "checkInternet", "top");
      return;

    } else if (error.status == 423 || error.status== 417) {
      this.common.errorMsg("", "youNeedLogin", "top");
      this.storage.clear('token');
      this.storage.clear('isUserLoggedIn');
      return;

    } else if (error.status == 400) {
      this.common.errorMsg("", "bad_request", "top");
      return;

    } else {
      this.common.errorMsg("", "", "top", "", error.message);
      return;

    }
  
  }

  otpNextPage() {  
    this.bsModalRef.hide();
    this.storage.store('localForgetLoginDevice', 'loginDevice');
    this.router.navigate(['/auth/login-verify-phone'], { state: { actionType: 'NEWDIVICE' }, replaceUrl: true });//test false to ture
  }

}
